import daska from './../assets/daska.png';
import daska1 from './../assets/daska1.png';
import daska2 from './../assets/daska2.png';
import zlatni_listici from './../assets/zlato_2.png';
import pigment from './../assets/pigment1.png';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { navList } from '../consts/global';
import { imagesCloudinaryHosted } from '../consts/imagesCloudinaryHosted';
export default function Home() {
  const { t } = useTranslation();
  return (
    <div className="mobile:w-full w-full bg-[#282c34] flex flex-col justify-center items-center">
      <Helmet>
        <title>Pocetna - Pravoslavne ikone - Nis</title>
        <meta
          name="description"
          content="Израда православних икона користећи традиционалну технику јајчане темпере и златне листиће, по канонима и са благословом. Контактирајте нас за ручно израђене иконе."
        />
        <meta
          name="keywords"
          content="иконописац, православне иконе, православне иконе продаја, јајчана темпера, златни листићи, израда икона"
        />
      </Helmet>
      <div className="bg-uvodHomeBg mobile:h-[100vh] mobile:w-full w-[90%] bg-cover bg-no-repeat bg-[50%_15%]">
        {' '}
        <h1
          className="mobile:text-[2.5rem] z-100 pt-[30px] !opacity-100 text-black font-extralight text-[3.5rem] font-pacifico text-center"
          lang="sr-Cyrl"
        >
          {t('izrada_pravoslavnih_ikona')}
        </h1>
        <p
          lang="sr-Cyrl"
          className="mobile:text-[1.2rem] mob font-pacifico text-black text-[2rem] text-center"
        >
          -{t('po_narudzbini')}-
        </p>
        <a
  href="/galerija"
  color='black'
  className="
    hidden mobile:flex 
    mx-auto mt-[20px] 
    w-[80%] text-center 
    bg-[#d4af37] !text-black 
    font-bold 
    py-[12px] px-[20px] 
    rounded-[20px] 
    shadow-md 
    active:scale-95 
    transition-all duration-200
    no-underline
    hover:scale-105
    align-center
    self-center
    justify-center
    hover:!text-black
    
  "
  lang="sr-Cyrl"
>
  {t('pogledaj_galeriju')} <span>{" "}</span>  <i className="fas fa-arrow-right self-center ml-1" style={{color:'black'}} aria-hidden="true"></i>
</a>

        <div className="mobile:flex-col mobile:flex-wrap mobile:w-full mobile:mt-[30px] mobile:bg-[#f5e7e74d] mt-[40px] flex !bg-[#3232324d] justify-around text-[#323232]">
          <ul className="mobile:pt-0 flex mobile:flex-col flex-wrap w-[70%] mobile:w-full">
            {
              navList?.map((a,i)=>{
                return(
            <li className="mobile:m-0 mobile:p-0 mobile:text-[18px] text-center  list-style-none pt-[30px] flex flex-col justify-around text-[2rem] mobile:w-full w-[50%]">
              <a
                className="mobile:p-[10px_0] hover:text-white hover:decoration-transparent mobile:hover:bg-[#1f1d1d75] hover:cursor-pointer  hover:font-bold hover:scale-110 transform transition-transform decoration-transparent font-extrabold text-black"
                lang="sr-Cyrl"
                href={a?.href}
              >
                {t(a?.text)}
              </a>
            </li>
                )
              })
            }
          </ul>
        </div>
      </div>

      <div className="">
        <div className="w-[90%] my-0 mx-auto mobile:mt-[50px] mobile:h-[100%] mobile:w-full">
          <h2 className="mobile:text-[2rem] font-pacifico text-[2.7rem] font-thin text-center">
            {t('vizantijski_stil')}
          </h2>
          <div className="text mobile:flex-col flex mt-[30px] justify-between">
            <p
              className="mobile:text-[1.2rem] text-justify font-cormorant m-[30px] text-[1.5rem]"
              lang="sr-Cyrl"
            >
              {t('vizantijski_stil_prvi_deo')}
            </p>

            <p
              className="mobile:text-[1.2rem] text-justify font-cormorant m-[30px] text-[1.5rem]"
              lang="sr-Cyrl"
            >
              {t('vizantijski_stil_drugi_deo')}
            </p>
          </div>
        </div>
        <div
        id='daska'
          className="mobile:h-[100%] mobile:w-full bg-no-repeat bg-cover w-[90%] m-[0_auto]"
        >
          <h2
            className="mobile:text-[2rem] mobile:pt-[2rem] text-white font-thin font-pacifico mb-[2rem] text-[2.7rem] text-center"
            lang="sr-Cyrl"
          >
            {t('tradicionalno_obradjena_lipova_daska')}
          </h2>
          <div className="textDaska flex justify-around mobile:flex-col mobile:m-[0_auto] mobile:w-[90%]">
            <img
              alt="daska, materijal, ikonopis"
              className="mobile:self-center w-[300px] rounded-[30px] mobile:mb-[1rem] max-w-[60%]"
              src={daska}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[300px] rounded-[30px] mobile:mb-[1rem] max-w-[60%]"
              src={daska1}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[300px] rounded-[30px] mobile:mb-[1rem] max-w-[60%]"
              src={daska2}
            ></img>
          </div>
          <p className="mobile:m-[0_auto] mobile:text-justify mobile:text-[1.2rem] w-[90%] m-[2rem_auto_0.5rem_auto] pb-[2rem] text-[1.5rem]
           font-cormorant">
            {t('daska_opis')}
          </p>
        </div>
    
        <div
          id="tehnika"
          className="flex flex-col w-[90%] m-[0_auto] mobile:w-full mobile:mt-[0.3rem]"
        >
          <h2
            className="mobile:pt-[1rem] mobile:text-[2rem] font-thin font-pacifico mb-[2rem] pt-[2rem] text-[2.7rem] text-center"
            lang="sr-Cyrl"
          >
            {t('tehnika_izrade')}
          </h2>
          <div className="slikeTehnika flex justify-around mobile:flex-col mobile:justify-around mobile:items-center">
            <img
              alt="tehnika, jajcana tempera, ikonopis"
              className="tehnika1 w-[20rem] h-auto rounded-[50px] mobile:mb-[1rem] max-w-[60%]"
              src={pigment}
            ></img>

            <img
              alt="tehnika, jajcana tempera, ikonopis"
              className="tehnika1 w-[20rem] h-auto rounded-[50px] max-w-[60%]"
              src={zlatni_listici}
            ></img>
          </div>
          <p
            lang="sr-Cyrl"
            className="mobile:mt-[1rem] mobile:text-justify mobile:text-[1.2rem] w-[90%] m-[2rem_auto_0.5rem_auto] pb-[2rem] text-[1.5rem] font-cormorant"
          >
            {t('pigmenti_zlato_opis')}
          </p>
        </div>
            {/*  */}
            <div
        id='slavskeIkone'
          className="mobile:h-[100%] mobile:w-full bg-no-repeat bg-cover w-[90%] m-[0_auto]"
        >
          <h2
            className="mobile:text-[2rem] mobile:pt-[2rem] text-white font-thin font-pacifico mb-[2rem] text-[2.7rem] text-center"
            lang="sr-Cyrl"
          >
            
            {t('izrada_slavskih_ikona')}
          </h2>
          <div className="textDaska flex justify-around mobile:flex-col mobile:m-[0_auto] mobile:w-[90%]">
            <img
              alt="daska, materijal, ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[35]}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[350px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[51]}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[350px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[94]}
            ></img>
          </div>
          <p className="mobile:m-[0_auto] mobile:text-justify mobile:text-[1.2rem] w-[90%] m-[2rem_auto_0.5rem_auto] pb-[2rem] text-[1.5rem]
           font-cormorant">
            {t('izrada_slavskih_ikona_tekst')}
          </p>
        </div>
        {/*  */}
        {/*  */}
        <div
        id='kompozicije'
          className="mobile:h-[100%] mobile:w-full bg-no-repeat bg-cover w-[90%] m-[0_auto]"
        >
          <h2
            className="mobile:text-[2rem] mobile:pt-[2rem] text-white font-thin font-pacifico mb-[2rem] text-[2.7rem] text-center"
            lang="sr-Cyrl"
          >
            {t('izrada_praznicnih_kompozicija')}
          </h2>
          <div className="textDaska flex justify-around mobile:flex-col mobile:m-[0_auto] mobile:w-[90%]">
            <img
              alt="daska, materijal, ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[96]}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[78]}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[47]}
            ></img>
          </div>
          <p className="mobile:m-[0_auto] text-center mobile:text-justify mobile:text-[1.2rem] w-[90%] m-[2rem_auto_0.5rem_auto] pb-[2rem] text-[1.5rem]
           font-cormorant">
            {t('izrada_praznicnih_kompozicija_tekst')}
          </p>
        </div>
        {/*  */}
         {/*  */}
         <div
        id='diptisi'
          className="mobile:h-[100%] mobile:w-full bg-no-repeat bg-cover w-[90%] m-[0_auto]"
        >
          <h2
            className="mobile:text-[2rem] mobile:pt-[2rem] text-white font-thin font-pacifico mb-[2rem] text-[2.7rem] text-center"
            lang="sr-Cyrl"
          >
            {t('izrada_diptiha')}
          </h2>
          <div className="textDaska flex justify-around mobile:flex-col mobile:m-[0_auto] mobile:w-[90%]">
            <img
              alt="daska, materijal, ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[67]}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[80]}
            ></img>
            <img
              alt="daska, materijal,ikonopis"
              className="mobile:self-center w-[300px] rounded-[10px] mobile:mb-[1rem] max-w-[60%]"
              src={imagesCloudinaryHosted[101]}
            ></img>
          </div>
          <p className="mobile:m-[0_auto] text-center mobile:text-justify mobile:text-[1.2rem] w-[90%] m-[2rem_auto_0.5rem_auto] pb-[2rem] text-[1.5rem]
           font-cormorant">
            {t('izrada_diptiha_tekst')}
          </p>
        </div>
        {/*  */}
      </div>
    </div>
  );
}
